<template lang="pug">
  .card
    .card-content
      .columns
        .column.is-6
          p.title
            | Ticket No. {{ ticket.id }}
          p.subtitle
            small.has-text-grey-darker Fecha Reg. &nbsp
            | {{ ticket.fechaReg }}
          span(v-html="getUbicacion(ticket.ubicacion, ticket.sitio)")
          p.has-text-grey.is-size-6
            | Solicita: 
            b {{ ticket.solicita }}
          p.has-text-grey.is-size-6
            | Departamento: 
            b {{ getDepartamento(ticket.departamento) }}
        .column.is-6
          p.has-text-grey.is-size-6
            | Equipo: 
            b {{ ticket.equipo }}
          p.has-text-grey.is-size-6
            | Modelo: 
            b {{ ticket.modelo }}
          p.has-text-grey.is-size-6
            | Problema: 
            b {{ ticket.problema }}
          
          hr
          p.has-text-grey.is-size-6
            b Atiende:
          .field.is-grouped.is-grouped-multiline
            .control(v-for="atends in ticket.atiende")
              .tags
                span.tag(:class="atends.idAtiende === ticket.idResuelve ? 'is-black' : 'is-light'" :key="atends.id") {{ atends.nombre }}
</template>

<script>
  export default {
    name: 'CardTicket',
    props: {
      ticket: {
        type: Object,
        default: ()=> {}
      },
    },
    methods: {
      getUbicacion (ubi, ofi) {
        let oficinaStr = ''
        switch (ofi) {
          case 'TPA-ALM':
            oficinaStr = 'Almacen'
            break
          case 'TPA-ALS':
            oficinaStr = 'Almacen Sist.'
            break
          case 'TPA-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'TPA-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'TPA-SERV':
            oficinaStr = 'Servidores'
            break;
          case 'TPA-IO':
            oficinaStr = 'Cuarto de IOS'
            break;
          case 'TPA-FAC':
            oficinaStr = 'Facturación'
            break
          case 'TPA-BAS':
            oficinaStr = 'Báscula'
            break
          case 'TPA-GER':
            oficinaStr = 'Gerencia'
            break
          case 'TPA-MUE':
            oficinaStr = 'Muelle'
            break
          case 'TPA-MANT':
            oficinaStr = 'Of. de Mntto.'
            break;
          case 'TPA-TALL':
            oficinaStr = 'Taller de Mntto.'
            break;
          case 'TPA-SEG':
            oficinaStr = 'Of. Seguridad'
            break;
          case 'TPA-PROP':
            oficinaStr = 'Of. Propangol'
            break;
          case 'TPA-MOV':
            oficinaStr = 'Of. Movenergy'
            break;
          case 'TPA-SJ':
            oficinaStr = 'Sala de Juntas'
            break;
          case 'TPA-ACC':
            oficinaStr = 'Accesos'
            break;
          case 'TPA-VIG':
            oficinaStr = 'Vigilancia'
            break;
          case 'TPA-ESF':
            oficinaStr = 'Esféricos'
            break;
          case 'TPA-LLEN':
            oficinaStr = 'Llenaderas'
            break;
          case 'TPA-SJ2':
            oficinaStr = 'Sala de Juntas 2'
            break;
          case 'TPA-REC':
            oficinaStr = 'Recepción'
            break;
          case 'IRGE-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'IRGE-ALM':
            oficinaStr = 'Almacen'
            break
          case 'IRGE-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'IRGE-FAC':
            oficinaStr = 'Facturación'
            break
          case 'IRGE-BAS':
            oficinaStr = 'Báscula'
            break
          case 'IRGE-GER':
            oficinaStr = 'Gerencia'
            break
          case 'IRGE-GADM':
            oficinaStr = 'Gerencia Admin.'
            break
          case 'IRGE-SJ':
            oficinaStr = 'Sala de Juntas'
            break
          case 'IRGE-SEG':
            oficinaStr = 'Seguridad'
            break
          case 'IRGE-IOS':
            oficinaStr = 'Cuarto de IOS'
            break
          case 'IRGE-PEM':
            oficinaStr = 'PEMEX'
            break
          case 'IRGE-ACC':
            oficinaStr = 'Accesos'
            break
          case 'IRGE-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'IRGE-CE':
            oficinaStr = 'Cuarto Eléctrico'
            break
          case 'IRGE-REC':
            oficinaStr = 'Recepción'
            break
          case 'IRGE-OP':
            oficinaStr = 'Operación'
            break
          case 'IRGE-CCP':
            oficinaStr = 'Cuarto Control Plus'
            break
          case 'IRGE-VP':
            oficinaStr = '23 Puntos'
            break
          case 'IRGE-MOV':
            oficinaStr = 'Movenergy'
            break
          case 'IRGE-VIC':
            oficinaStr = 'Vigilancia CUSAEM'
            break
          case 'EB04-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB04-ALG':
            oficinaStr = 'Almacén GIA'
            break
          case 'EB04-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB04-GER':
            oficinaStr = 'Gerencia'
            break
          case 'EB04-SIS':
            oficinaStr = 'Sistemas'
            break
          case 'EB04-INS':
            oficinaStr = 'Instrumentación'
            break
          case 'EB04-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB04-SG':
              oficinaStr = 'Sala de Juntas'
              break
          case 'EB04-TIA':
            oficinaStr = 'Taller Inst/Aut'
            break
          case 'EB03-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB03-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB03-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB02-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB02-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB02-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB01-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB01-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB01-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'EB00-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'EB00-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'EB00-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'ERM-CC':
            oficinaStr = 'Cuarto de Control'
            break
          case 'ERM-ADM':
            oficinaStr = 'Of. Admin.'
            break
          case 'ERM-VIG':
            oficinaStr = 'Vigilancia'
            break
          case 'VALV-ADM':
            oficinaStr = 'Gabinete'
            break
          case 'CORP-DIR':
            oficinaStr = 'Dirección'
            break
          case 'CORP-GG':
            oficinaStr = 'Gerencia General'
            break
          case 'CORP-GC':
            oficinaStr = 'Contraloría'
            break
          case 'CORP-C':
            oficinaStr = 'Contabilidad'
            break
          case 'CORP-CP':
            oficinaStr = 'Cuentas por Pagar'
            break
          case 'CORP-F':
            oficinaStr = 'Fiscal'
            break
          case 'CORP-SA':
            oficinaStr = 'Seguimiento Ambiental'
            break
          case 'CORP-GR':
            oficinaStr = 'Regulación'
            break
          case 'CORP-ALM':
            oficinaStr = 'Almacén'
            break
          case 'CORP-ALG':
            oficinaStr = 'Almacén GIA'
            break
          case 'CORP-GIS':
            oficinaStr = 'Gerencia Inst. y Sist.'
            break
          case 'CORP-SIT':
            oficinaStr = 'Site'
            break
          case 'CORP-RH':
            oficinaStr = 'Recursos Humanos'
            break
          case 'CORP-LEG':
            oficinaStr = 'Legal'
            break
          case 'CORP-REC':
            oficinaStr = 'Recepción'
            break
          case 'LPGD-V1':
            oficinaStr = 'Válvula 1'
            break
          case 'LPGD-V2':
            oficinaStr = 'Válvula 2'
            break
          case 'LPGD-V3':
            oficinaStr = 'Válvula 3'
            break
          case 'LPGD-V4':
            oficinaStr = 'Válvula 4'
            break
          case 'LPGD-V5':
            oficinaStr = 'Válvula 5'
            break
          case 'LPGD-V6':
            oficinaStr = 'Válvula 6'
            break
          case 'LPGD-V7':
            oficinaStr = 'Válvula 7'
            break
          case 'LPGD-V8':
            oficinaStr = 'Válvula 8'
            break
          case 'LPGD-V9':
            oficinaStr = 'Válvula 9'
            break
          case 'LPGD-V10':
            oficinaStr = 'Válvula 10'
            break
          case 'LPGD-V11':
            oficinaStr = 'Válvula 11'
            break
          case 'LPGD-V12':
            oficinaStr = 'Válvula 12'
            break
          case 'LPGD-V13':
            oficinaStr = 'Válvula 13'
            break
          case 'LPGD-V14':
            oficinaStr = 'Válvula 14'
            break
          case 'LPGD-V15':
            oficinaStr = 'Válvula 15'
            break
          case 'LPGD-V16':
            oficinaStr = 'Válvula 16'
            break
          case 'LPGD-V17':
            oficinaStr = 'Válvula 17'
            break
          case 'LPGD-V18':
            oficinaStr = 'Válvula 18'
            break
          case 'LPGD-V19':
            oficinaStr = 'Válvula 19'
            break
          case 'LPGD-V20':
            oficinaStr = 'Válvula 20'
            break
          case 'LPGD-V21':
            oficinaStr = 'Válvula 21'
            break
          case 'LPGD-V22':
            oficinaStr = 'Válvula 22'
            break
          case 'LPGD-V23':
            oficinaStr = 'Válvula 23'
            break
          case 'LPGD-V24':
            oficinaStr = 'Válvula 24'
            break
          case 'LPGD-V25':
            oficinaStr = 'Válvula 25'
            break
          case 'LPGD-V26':
            oficinaStr = 'Válvula 26'
            break
          case 'LPGD-V1B':
            oficinaStr = 'Válvula 1 BIS'
            break
          case 'LPGD-V2B':
            oficinaStr = 'Válvula 2 BIS'
            break
          case 'LPGD-V3B':
            oficinaStr = 'Válvula 3 BIS'
            break
          case 'LPGD-V4B':
            oficinaStr = 'Válvula 4 BIS'
            break
          case 'LPGD-V5B':
            oficinaStr = 'Válvula 5 BIS'
            break
          case 'LPGD-INT':
            oficinaStr = 'Interconexión'
            break
          case 'TPA-RV':
            oficinaStr = 'Recuperador de vapores'
            break
          case 'TPA-PM':
            oficinaStr = 'Paquete de Medición'
            break
          case 'TPA-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'TPA-SISV':
            oficinaStr = 'Sistema Vickers'
            break
          case 'TPA-SCI':
            oficinaStr = 'Sist. Contra Incendio'
            break
          case 'TPA-CB':
            oficinaStr = 'Cuarto de Baterias'
            break
          case 'EB00-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'EB00-CB':
            oficinaStr = 'Cuarto de Baterias'
            break
          case 'EB00-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'EB00-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'EB00-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'ERM-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'ERM-SAL':
            oficinaStr = 'Salida IRGE'
            break
          case 'ERM-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'ERM-TP':
            oficinaStr = 'Tanque Pulmón'
            break
          case 'ERM-TPRG':
            oficinaStr = 'Tanque de Purga'
            break
          case 'ERM-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'EB04-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'EB04-CAB':
            oficinaStr = 'Cabezales'
            break
          case 'EB04-CB':
            oficinaStr = 'Cobertizo de Bombas'
            break
          case 'EB04-COC':
            oficinaStr = 'Cocina'
            break
          case 'EB04-CTE':
            oficinaStr = 'Cuarto Eléctrico'
            break
          case 'EB04-GEN':
            oficinaStr = 'Generadores'
            break
          case 'EB04-PM':
            oficinaStr = 'Patín de Medición'
            break
          case 'EB04-RP':
            oficinaStr = 'Residuos Peligrosos'
            break
          case 'EB04-TALL':
            oficinaStr = 'Taller y Almacén'
            break
          case 'EB04-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'EB04-TORG':
            oficinaStr = 'Tanque de Purga'
            break
          case 'EB04-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'EB04-TRA':
            oficinaStr = 'Transformador'
            break
          case 'IRGE-BOM':
            oficinaStr = 'Bombas LPG'
            break
          case 'IRGE-BP':
            oficinaStr = 'Bombas de Proceso'
            break
          case 'IRGE-CB':
            oficinaStr = 'Cuarto de Bombas'
            break
          case 'IRGE-CCM':
            oficinaStr = 'CCM'
            break
          case 'IRGE-CI':
            oficinaStr = 'Red C.I.'
            break
          case 'IRGE-COMP':
            oficinaStr = 'Area de Compresores'
            break
          case 'IRGE-CONT':
            oficinaStr = 'Contabilidad'
            break
          case 'IRGE-CUB':
            oficinaStr = 'Cubeta'
            break
          case 'IRGE-ESF':
            oficinaStr = 'Esferas'
            break
          case 'IRGE-LLEN':
            oficinaStr = 'Llenaderas'
            break
          case 'IRGE-MANT':
            oficinaStr = 'Of. Mantenimiento'
            break
          case 'IRGE-PROP':
            oficinaStr = 'Of. Propangol'
            break
          case 'IRGE-TA':
            oficinaStr = 'Tanque de Agua'
            break
          case 'IRGE-TD':
            oficinaStr = 'Trampa de Diablos'
            break
          case 'IRGE-TP':
            oficinaStr = 'Tanque Pulmón'
            break
          case 'IRGE-TR':
            oficinaStr = 'Tren de Regulación'
            break
          case 'IRGE-TRA':
            oficinaStr = 'Area de Trasiegos'
            break
        }
        return `<div class="control">
          <div class="tags has-addons">
            <span class="tag is-dark"><i class="fas fa-map-pin"></i>&nbsp${ubi}</span>
            <span class="tag is-primary">${oficinaStr}</span>
          </div>
        </div>`
      },
      convertSitio (sit) {
        console.log(sit)
        switch (sit) {
          case 'fac':
            return 'Facturación'
            break
          case 'bas':
            return 'Báscula'
            break
          case 'acc':
            return 'Accesos'
            break
          case 'adm':
            return 'Oficinas Administrativas'
            break
          case 'cco':
            return 'Cuarto de Control'
            break
          case 'mue':
            return 'Muelle'
            break
          case 'llen':
            return 'Llenaderas'
            break
          case 'esf':
            return 'Esferas'
            break
          case 'vap':
            return 'Recuperador de Vapores'
            break
          case 'bom':
            return 'Bombas'
            break
        
          default:
            break;
        }
      },
      getDepartamento (depto) {
        let stringDepto = ''
        switch (depto) {
          case 0:
            stringDepto =  'Gerencia'
            break
          case 1:
            stringDepto =  'Instrumentación'
            break
          case 2:
            stringDepto =  'Administración'
            break
          case 3:
            stringDepto =  'Sistemas'
            break
          case 4:
            stringDepto =  'Operación'
            break
          case 5:
            stringDepto =  'Mantenimiento'
            break
          case 6:
            stringDepto =  'Instrum. - Sistmas'
            break
          case 7:
            stringDepto =  'Seguridad'
            break
          case 8:
            stringDepto =  'Externo'
            break
          case 9:
            stringDepto =  'Público'
            break
          case 21:
            stringDepto =  'Contraloría'
            break
          case 22:
            stringDepto =  'Contabilidad'
            break
          case 23:
            stringDepto =  'Cuentas por pagar'
            break
          case 24:
            stringDepto =  'Fiscal'
            break
          case 25:
            stringDepto =  'Legal'
            break
          case 71:
            stringDepto =  'Seguimiento Ambiental'
            break
          case 72:
            stringDepto =  'Regulación'
            break
          case 73:
            stringDepto =  'Procesos y Proc.'
            break

          default:
            break
        }
        return stringDepto
      },
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/CardTicket.vue